export default "__VITE_ASSET__HYztiAXn__"